import { render, staticRenderFns } from "./AddNewDeposit.vue?vue&type=template&id=0ad5a254&scoped=true&"
import script from "./AddNewDeposit.vue?vue&type=script&lang=ts&"
export * from "./AddNewDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewDeposit.vue?vue&type=style&index=0&id=0ad5a254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad5a254",
  null
  
)

export default component.exports